<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title59"></a>
<div class="p-d-br"><span>To Donna, John, and Emily. <br/>Now you’re in two books.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429954068_ded01.vue?340ca9cc